import React from "react";
import { UserAvatar } from "components/UserAvatar/UserAvatar";
import { getTranslation as translate } from "logic/LocaleManager";

// Externals
import cn from "classnames";

// Component styles
import classes from "./UserInfo.module.scss";

function UserInfo(props) {
  const { userName, navigateTo } = props;

  return (
    <div className={classes.userInfo}>
    <UserAvatar userName={userName} hint={translate("general.account", "Account")} onClicked={() => navigateTo("/account")} />
    <div className={cn(classes.userText, "ui-font-bigger-1", "ui-font-bold-1")}>{userName}</div>
  </div>
  );
}
export default (UserInfo);
